import React, { Fragment } from 'react';

import Checkbox from '@usas/ui-web/components/checkboxes/Checkbox';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import { FormatMoneyWithSymbol } from '@usas/ui-web/utils/FormatMoney';

import { VisuallyHidden } from '@reach/visually-hidden';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import style from '../../Omr.module.css';

const GridRowIcons = ({ offering, restrictions, onChanged, isChecked, onDetailsToggle, expandedId }) => (
  <Fragment>
    <Checkbox
      label={offering.clubBulkRenewalOptIn === true ? "Club is Renewing" : ""}
      name="offeringInstanceId"
      onChange={(checked) => onChanged(checked, offering, offering.offeringInstanceId, offering.offeringId)}
      checked={isChecked}
      disabled={restrictions?.find(x => x.offeringId === offering.offeringId) || offering.clubBulkRenewalOptIn === true ? true : false} />
    {offering?.offeringDescription &&
      <button
        className={[global.IconButton, style.MarginTopDetails].join(' ')}
        type="button"
        onClick={(e) => onDetailsToggle(e, offering.offeringInstanceId)}>
        <VisuallyHidden>{expandedId === offering.offeringInstanceId ? 'Hide' : 'Show'}Detail for{offering.offeringName}</VisuallyHidden>
        <span className={style.MembershipDetails}>Details</span>
      </button>
    }
  </Fragment>
);

const GridRowContent = ({ offering, restrictions, expandedId }) => (
  <div className={global.SmallTableRowInfo}>
    <div className={['row', (restrictions?.find(x => x.offeringId === offering.offeringId) || offering.clubBulkRenewalOptIn === true ? style.IsSelected : style.NotSelected)].join(' ')}>
      <div className={['col-xs-6 col-sm-3 visible-xs', global.SmallTableRowLabels].join(' ')}>
        Membership Name
      </div>
      <div className={['col-xs-6 col-sm-3 visible-xs', global.SmallTableRowData].join(' ')}>
        {offering.offeringName}
      </div>
      <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
        Expiration Date
      </div>
      <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
        {formatDate(offering.expirationDate)}
      </div>
      <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
        Total Fee
      </div>
      <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
        {FormatMoneyWithSymbol(offering.totalFeesAmount)}
      </div>
      {expandedId === offering.offeringInstanceId &&
        <div>
          <p className={style.ShowDetailsSmall}>
            {offering.offeringDescription}
          </p>
        </div>}
    </div>
  </div>
);

const GridRow = ({ offering, restrictions, onChanged, isChecked, showDetails, onDetailsToggle, expandedId }) => {
  return (
    <Fragment>
      <div className={global.SmallTableRow}>
        <div className={global.SmallTableRowHead}>
          <span className='hidden-xs'>{offering.offeringName}</span>&nbsp;
          <GridRowIcons
            id={offering.offeringInstanceId}
            offering={offering}
            restrictions={restrictions}
            onChanged={onChanged}
            isChecked={isChecked}
            showDetails={showDetails}
            onDetailsToggle={onDetailsToggle}
            expandedId={expandedId} />
        </div>
        <GridRowContent offering={offering} restrictions={restrictions} showDetails={showDetails} expandedId={expandedId} />
      </div>
    </Fragment>
  );
}

const SmallOfferingsGrid = ({ state, selectedOfferingTypeIds, restrictions, onChanged, showDetails, onDetailsToggle, expandedId }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {state?.isArrayLoaded !== true
      ? (<div className={global.SmallTableRow}>
        <div className={global.SmallTableRowHead}>
          &nbsp;
        </div>
        <div className={global.SmallTableRowInfo}>
          {state?.isArrayLoading === true
            ? <div className={global.SmallTableRowLabels}>Loading... </div>
            : <div className={global.SmallTableRowLabels}>No USA Swimming Memberships with this Club are Currently Available</div>}
        </div>
      </div>)
      : Array.isArray(state?.arrayData) === true
        && state?.arrayData.length > 0
        ? state?.arrayData.map((offering, i) => {
          const foundIndex = selectedOfferingTypeIds.indexOf(offering.offeringInstanceId);
          return (
            <GridRow
              key={i}
              offering={offering}
              restrictions={restrictions}
              onChanged={onChanged}
              isChecked={foundIndex >= 0}
              showDetails={showDetails}
              onDetailsToggle={onDetailsToggle}
              expandedId={expandedId}
            />)
        })
        : (<div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>
            &nbsp;
          </div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>No USA Swimming Memberships with this Club are Currently Available</div>
          </div>
        </div>)
    }
  </div>
);

export default SmallOfferingsGrid;